import type { SectorValue } from "../context/OnboardingContext";

/** The badge of the hub's «Settore» card (AC24). */
export type HubSectorState = "review" | "todo" | "done";

/**
 * The state of the hub's «Settore» card (AC24, freelancer-categories FE14):
 * - `todo` («Da completare») without a primary sector, as the other cards;
 * - `review` («Da controllare») while a primary is there (from LinkedIn) but
 *   the freelancer has not opened the modal and saved it once;
 * - `done` («Completato») after the first «Salva».
 */
export function hubSectorState(sector: {
  value: SectorValue;
  reviewed: boolean;
}): HubSectorState {
  if (!sector.value.job_category) return "todo";
  return sector.reviewed ? "done" : "review";
}

/**
 * The choices of the card's line: «X + Y · N ambiti» (AC24). The secondary
 * counts only if it differs from the primary; the count is left out at 0.
 * Empty without a primary. Labels and the count text come from the caller, so
 * this stays free of the store and of i18n.
 */
export function hubSectorLabels(
  value: SectorValue,
  text: {
    category: (key: string) => string;
    areas: (count: number) => string;
  },
): string {
  const primary = value.job_category;
  if (!primary) return "";
  const secondary =
    value.job_category_secondary && value.job_category_secondary !== primary
      ? value.job_category_secondary
      : null;
  const sectors = [primary, secondary]
    .filter((key): key is NonNullable<typeof key> => !!key)
    .map(text.category)
    .join(" + ");
  const count = value.job_subcategories.length;
  return count > 0 ? `${sectors} · ${text.areas(count)}` : sectors;
}
